import React, { Component } from "react";
import { Modal } from "reactstrap";

import ModalStyles from "./Modal.css";
import HelpModalStyles from "./HelpModal.css";

import Pattern1 from "../images/pattern-1.png";
import Pattern2 from "../images/pattern-2.png";
import Pattern3 from "../images/pattern-3.png";

/* eslint-disable import/no-webpack-loader-syntax */

import CloseIcon from "-!svg-react-loader!../icons/close.svg";

class HelpModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: this.props.open
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ modal: nextProps.open });
  }

  toggle = () => {
    // this.setState({
    //     modal: !this.state.modal
    // });
    this.props.closeHelpModal();
  };

  close = () => {
    this.props.closeHelpModal();
  };

  apply = () => {
    this.setState({
      modal: !this.state.modal
    });
  };

  render() {
    let type = this.props.type;
    let description = "";
    let infoDOM = "";

    switch (type) {
      case "Mat width":
        description = `
                    The mat border is made up of a thick, flat piece of paper-based material which sits between the acrylic and your framed item. Our mat boards are all acid-free and will help to preserve your framed items.<br /><br />
                    The border exists in framing for two main reasons:<br /><br />
                    Firstly, the wide range of colours enables you to play around with different styles to match your needs. Most people may go with a simple white mat border, but our builder allows you to consider many other options to match your style.<br /><br />
                    Secondly, the mat border separates your item from the acrylic glazing. In humid countries, condensation can develop on the inside of the acrylic, and when no mat border is present, this can be directly transferred to the item you are framing, resulting in water damage, mould or mildew.<br /><br />
                    Photographs should also be separated with a mat border, as condensation can result in the photograph sticking to the acrylic.
                `;
        break;

      case "Glaze Options":
        description = `
                    Glaze covers and protects your artwork from dust and various other external elements. We use acrylic due to its strength, lightness, clarity and safety. We offer the following options. Please contact us if you require any more information.<br /><br />
                    <h3>Standard Acrylic</h3>
                    <p>A good quality acrylic with basic UV protection. A fine choice for most photos, posters and prints. Avoid hanging in direct sunlight or under strong internal lights.</p>
                    <h3>Enhanced UV Protection</h3>
                    <p>Provides the highest level of protection against damaging ultraviolet (UV) rays created from light sources. Helps to prevent fading or yellowing of paper-based artwork.</p>
                `;
        break;

      case "Hanging Options":
        description = `
                The options available will depend on the size of your final frame. You may also choose not to include any hanging option.<br /><br />
                    <h3>Wire</h3>
                    <p>The wire option is perfect for hanging your frame on the wall. It is available on all sizes, and our website will auto select the appropriate hooks and cables to safely hold the weight of your frame.</p>
                    <h3>Stand</h3>
                    <p>For smaller frame sizes we can install a table top stand if you’d prefer.</p>
                `;
        break;
      case "Window size":
        description = `
                      <p>The window size refers to what will be visible within the mat window after accounting for the mat border overlapping your item. We need to allow for overlap to ensure your item doesn’t just fall out of the window. By default, we apply 1.2cm of overlap to both the height and width of your work [6mm each side].</p>
                      <p>For example, if your artwork is measured 30 cm x 30cm the window size will be 28.8cm x 28.8cm. This provides you with 1.2cm to overlap your work with the mat border when mounting.</p>
                      <p>Please note, if your item has a blank border around the printed area, you can adjust your size inputs to minimise the overlap of your printed area. To do this, measure the height and width of your printed area and then add 1cm to the height and width you input in the frame builder. You could add 1.2cm, but we feel it is better to have a little allowance.</p>
                      <p>You can then check back and see the window size will have increased. This is only applicable when framing with a mat border.</p>
                      <p>If you aren’t sure, please get in touch and we are happy to guide you.</p>
                  `;
        break;

      default:
    }

    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        className='help-modal'
      >
        <CloseIcon
          className='close-btn'
          onClick={() => {
            this.close();
          }}
        />
        <div className='body'>
          <h2>{this.props.type}</h2>
          <p dangerouslySetInnerHTML={{ __html: description }}></p>
        </div>
        {/*<hr />
                <div className="foot">
                    {infoDOM}
                </div>*/}
      </Modal>
    );
  }
}

export default HelpModal;



// WEBPACK FOOTER //
// ./src/components/HelpModal.js